
















































import Vue from 'vue';
import axios from 'axios';

export type DataType = {
  articleList: Array<any>;
  lgtmCount: number;
  plusCount: number[];
  selected: string;
}

export default Vue.extend({
  name: 'DisplayQiitaTrend',
  data(): DataType {
    return {
      articleList: [],
      lgtmCount: 0,
      plusCount: new Array(30).fill(0),
      selected: '無限LGTMモード',
    }
  },
  created() {
    axios
      .get(process.env.VUE_APP_QIITA_TREND_URL) //qiitaトレンドを取得するAPI-URL
      .then(response => {
        this.articleList = response.data
      })
      .catch(error => {
        alert('httpリクエストに失敗しました')
      });
  },
  methods: {
    increment(index: number) {
      if (this.selected == '無限LGTMモード') {
        this.$set(this.plusCount, index, this.plusCount[index] + 1);
        return;
      }
      if (this.plusCount[index] >= 5000000000000000) {
        return
      }
      this.$set(this.plusCount, index, this.plusCount[index] + 5000000000000000)
    }
  }
});
